import { CheckCircleFilled, ExperimentFilled } from '@ant-design/icons';

/**
 * Template category badge. CURATED = authored and maintained by the platform team; its regNotes say what has been reviewed. ESTATE_CANDIDATE = harvested
 * from the demo estate (ADR-012 #10) — NOT yet SIGNAL-reviewed, may carry non-canonical families.
 * Colour is always paired with a glyph + text (deuteranopia-safe).
 */
export function CategoryBadge({ category }: { category: string }) {
  const c = category?.toUpperCase?.() ?? '';
  const curated = c === 'CURATED';
  const estate = c === 'ESTATE_CANDIDATE';
  const color = curated ? 'var(--ol-positive)' : estate ? 'var(--ol-attention)' : 'var(--ol-text-tertiary)';
  const label = curated ? 'Curated' : estate ? 'Estate candidate' : category || 'Uncategorised';
  const Icon = curated ? CheckCircleFilled : ExperimentFilled;
  return (
    <span
      title={
        curated
          ? 'Curated — authored and maintained by the platform team. See its regulatory notes.'
          : estate
            ? 'Estate candidate — harvested from the demo estate, not yet SIGNAL-reviewed.'
            : label
      }
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        color,
        fontSize: 10.5,
        fontWeight: 700,
        padding: '1px 8px',
        borderRadius: 999,
        border: '1px solid currentColor',
        background: 'color-mix(in srgb, currentColor 10%, transparent)',
        whiteSpace: 'nowrap',
      }}
    >
      <Icon aria-hidden />
      {label}
    </span>
  );
}
